/**
 * Returns a cleaned copy of the given object.
 *
 * This function uses JSON serialization to create a deep copy,
 * which removes non-JSON-serializable values like functions and symbols.
 */
export default function cleanSource<T>(object: T): T {
  return JSON.parse(JSON.stringify(object)) as T
}
